import { render, staticRenderFns } from "./CookieNotification.vue?vue&type=template&id=fda87af8"
import script from "./CookieNotification.vue?vue&type=script&lang=js"
export * from "./CookieNotification.vue?vue&type=script&lang=js"
import style0 from "./CookieNotification.vue?vue&type=style&index=0&id=fda87af8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports